"use client";

import { useEffect } from 'react';
import { createClient } from '@/utils/supabase/client';
import { NextIntlClientProvider } from 'next-intl';
import { ModalProvider } from '@/context/ModalContext';
import ClientLayout from "@/components/LayoutClient";
import { UserContextProvider } from "@/context/UserContext";
import { Suspense } from 'react';
import { logger } from '@/lib/logger';
import { SidebarProvider } from '@/contexts/SidebarContext';
import { i18nOptimizer } from '@/utils/i18nOptimizer';

export default function RootClientLayout({ children, messages, locale }) {
  // 使用全局 Supabase 客户端管理器
  const supabase = createClient();

  useEffect(() => {
    // 🔥 初始化国际化优化
    const cleanup = i18nOptimizer.init(locale);
    
    // 在空闲时间预加载次要组件翻译
    const preloadSecondaryTranslations = () => {
      if (typeof requestIdleCallback !== 'undefined') {
        requestIdleCallback(() => {
          i18nOptimizer.preload(locale, ['videocard', 'pricing', 'veo3']);
        }, { timeout: 3000 });
      } else {
        setTimeout(() => {
          i18nOptimizer.preload(locale, ['videocard', 'pricing', 'veo3']);
        }, 2000);
      }
    };

    // 延迟预加载次要翻译
    setTimeout(preloadSecondaryTranslations, 1000);

    // 开发环境下的性能监控
    if (process.env.NODE_ENV === 'development') {
      // 每5分钟输出一次性能报告
      const performanceInterval = setInterval(() => {
        const report = i18nOptimizer.getPerformanceReport();
        if (Object.keys(report).length > 0) {
          console.log('🎯 I18n Performance Report:', report);
        }
      }, 5 * 60 * 1000);

      return () => {
        cleanup();
        clearInterval(performanceInterval);
      };
    }

    return cleanup;
  }, [locale]);

  return (
    <NextIntlClientProvider 
      messages={messages} 
      locale={locale}
      timeZone="Asia/Shanghai"
      now={new Date()}
    >
      <ModalProvider>
        <ClientLayout>
          <UserContextProvider>
            <SidebarProvider>
            <div className="flex flex-col">
              <Suspense fallback={<div className="h-16 bg-black" />}>
              </Suspense>
              <main className="overflow-x-hidden flex-1">
                {children}
              </main>
            </div>
            </SidebarProvider>
          </UserContextProvider>
        </ClientLayout>
      </ModalProvider>
    </NextIntlClientProvider>
  );
} 